import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const infiniteScrollTabbingRolesRBAC = {
  pageID: '45165291de2f376a32baf7aa803c80c1',
  elementID: {
    ViewPage: '3555d9a886e66f764227509412e43c0f',
    ButtonCreateTab: 'a589f58c26769165cbdd6f78effa6630',
    ButtonEditTab: 'd2c9cb264eb6bcd6dba9ba8a99a71334',
    ButtonDeleteTab: '24b7f9e8a8e164db7ee26bb31a2d17d3',
    ButtonToggleStatusTab: '6f39b171ca7d2f33adf6716e5dbd0236',
    UpdatePositionTab: '168aa0066f0b960b1f76ece6ccab9b61',
  },
} as const

export const useRBACInfiniteScrollTabbingPage = createUseRBAC(
  infiniteScrollTabbingRolesRBAC.elementID,
)

export type UseRBACInfiniteScrollTabbingPageType = ReturnType<
  typeof useRBACInfiniteScrollTabbingPage
>
